import { clsx } from 'clsx';
import { Checkbox, FormControlLabel } from '@material-ui/core';

import { ItemAvatar } from 'shared/components/item-avatar';

import makeClasses from './CheckboxOption.style';

import type { CheckboxOptionProps } from './checkboxOption.model';

export function CheckboxOption(props: CheckboxOptionProps) {
  const {
    variant = 'default',
    fullWidth = true,
    classes = {},
    activeItemAvatar = false,
    itemAvatarProps = {},
    title,
    description,
    children = null,
    checkboxProps = {},
    ...restFormControlLabelProps
  } = props;

  const _classes = makeClasses({ variant, fullWidth });

  return (
    <FormControlLabel
      labelPlacement='start'
      classes={{
        ...classes?.formControlLabel,
        root: clsx(_classes.root, classes?.formControlLabel?.root),
      }}
      label={
        <div className={clsx(_classes.labelRoot, classes?.label?.root)}>
          {activeItemAvatar && <ItemAvatar {...itemAvatarProps} />}
          <main className={clsx(_classes.labelMain, classes?.label?.main)}>
            {Boolean(title) && (
              <h3 className={clsx(_classes.labelTitle, classes?.label?.title)}>
                {title}
              </h3>
            )}
            {Boolean(description) && (
              <p
                className={clsx(
                  _classes.labelDescription,
                  classes?.label?.description,
                )}
              >
                {description}
              </p>
            )}
            {children}
          </main>
        </div>
      }
      control={
        <Checkbox
          disableRipple
          color='default'
          classes={{
            ...checkboxProps?.classes,
            root: clsx(_classes.check, checkboxProps?.classes?.root),
            checked: clsx(_classes.checked, checkboxProps?.classes?.checked),
          }}
        />
      }
      {...restFormControlLabelProps}
    />
  );
}
